import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createFolderUser = async (token, params) => {
  const objectName = 'folder_user'
  const url = `folders/${params.folder_id}/folder_users`

  await apiPost({ url, token, objectName, params })
}

export function useCreateFolderUser({ options }) {
  const token = useContext(AuthContext)
  return useMutation(
    (params) => createFolderUser(token, params),
    { ...options }
  )
}

const updateFolderUser = async (token, id, params) => {
  const objectName = 'folder_user'
  const url = `folder_users/${id}`

  return await apiPatch({ url, token, objectName, params })
}

export function useUpdateFolderUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    (params) => updateFolderUser(token, id, params),
    { ...options }
  )
}

const destroyFolderUser = async (token, id) => {
  const url = `folder_users/${id}`

  await apiDelete({ url, token })
}

export function useDestroyFolderUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => destroyFolderUser(token, id),
    { ...options }
  )
}
